/**
 * When REACT_APP_MARKETPLACE_ROOT_URL (baked at build time) does not match
 * window.location.origin, Stripe.js iframes and other postMessage-based flows
 * can log "target origin does not match the recipient window's origin".
 * Fix: set the env to the exact public URL (including www vs apex) and add
 * that domain in Stripe Dashboard → Settings → Allowed domains.
 */

const WARN_KEY = '__FYK_MARKETPLACE_ORIGIN_WARNED__';

/**
 * True when the build was made with a staging marketplace URL (REACT_APP_MARKETPLACE_ROOT_URL).
 * Used for staging-only UI such as the footer badge; live builds return false.
 */
export function isStagingMarketplaceBuild() {
  const baked = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
  if (!baked) {
    return false;
  }
  try {
    const hostname = new URL(baked).hostname.toLowerCase();
    return hostname.includes('staging');
  } catch (e) {
    return false;
  }
}

export function warnIfMarketplaceOriginMismatch() {
  if (typeof window === 'undefined') {
    return;
  }
  if (window[WARN_KEY]) {
    return;
  }
  const baked = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
  if (!baked) {
    return;
  }
  let expected;
  try {
    expected = new URL(baked).origin;
  } catch (e) {
    return;
  }
  const actual = window.location.origin;
  if (expected !== actual) {
    window[WARN_KEY] = true;
    // eslint-disable-next-line no-console
    console.warn(
      '[FYK] Page origin does not match REACT_APP_MARKETPLACE_ROOT_URL. ' +
        'Fix the env to your live URL (www vs non-www must match). Stripe/postMessage errors often follow. ' +
        'Expected:',
      expected,
      'Actual:',
      actual
    );
  }
}
